import { render, staticRenderFns } from "./publishProduct.vue?vue&type=template&id=4668fcad&scoped=true&"
import script from "./publishProduct.vue?vue&type=script&lang=js&"
export * from "./publishProduct.vue?vue&type=script&lang=js&"
import style0 from "./publishProduct.vue?vue&type=style&index=0&id=4668fcad&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668fcad",
  null
  
)

export default component.exports